import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'

interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  large?: boolean
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, large = false, ...props }, ref) => (
  <CheckboxPrimitive.Root
    data-slot="control"
    ref={ref}
    className={cn(
      'group/checkbox relative',
      large ? 'size-5' : 'size-4',
      className,
    )}
    {...props}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 m-auto h-full w-full opacity-0 transition-all group-data-[state=unchecked]/checkbox:opacity-100"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 1.6H3C2.2268 1.6 1.6 2.2268 1.6 3V17C1.6 17.7732 2.2268 18.4 3 18.4H17C17.7732 18.4 18.4 17.7732 18.4 17V3C18.4 2.2268 17.7732 1.6 17 1.6ZM3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3Z"
        fill="#64748B"
      />
    </svg>

    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 m-auto h-full w-full opacity-0 transition-all group-data-[state=indeterminate]/checkbox:opacity-100"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3ZM6.66667 9C6.11438 9 5.66667 9.44771 5.66667 10C5.66667 10.5523 6.11438 11 6.66667 11L13.3333 11C13.8856 11 14.3333 10.5523 14.3333 10C14.3333 9.44772 13.8856 9 13.3333 9L6.66667 9Z"
        fill="#0969DA"
      />
    </svg>

    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="absolute inset-0 m-auto h-full w-full opacity-0 transition-all group-data-[state=checked]/checkbox:opacity-100"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3ZM15.6364 7.08252C15.9879 6.73105 15.9879 6.1612 15.6364 5.80973C15.2849 5.45826 14.7151 5.45826 14.3636 5.80973L8.07754 12.0958L5.59924 9.88419C5.22837 9.55324 4.65945 9.5856 4.3285 9.95646C3.99755 10.3273 4.0299 10.8962 4.40076 11.2272L7.51347 14.0049C7.86952 14.3226 8.41167 14.3072 8.7491 13.9698L15.6364 7.08252Z"
        fill="#0969DA"
      />
    </svg>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
